const initialState = {
	priorities: [],
	types: []
};

const eventLookups = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "EVENT_LOOKUPS_RECEIVED": {
			return payload;
		}
		default:
			return state;
	}
};

export default eventLookups;
